<template>
  <div class="hotelTour">
    <h3 class="hotelH3">
      <tk-svg-icon class="icoTour" icon="tour" />
      パックでお得なツアー
    </h3>

    <div class="hotelTourInner">
      <ul class="hotelTourList">
        <tk-packback-tour
          v-for="(tour, idx) in tours"
          :key="idx"
          :hotel-name="tour.hotelName"
          :min-price="tour.minPrice"
          :max-price="tour.maxPrice"
          :title="tour.title"
          :departure="tour.departure"
          :duration="tour.duration"
          :link="tour.link"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import TkSvgIcon from '../../atoms/TkIcon/TkSvgIcon.vue'
import TkPackbackTour from './TkPackbackTour.vue'

export default {
  name: 'TkPackbackTours',
  components: {
    TkPackbackTour,
    TkSvgIcon,
  },
  props: {
    tours: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkPackbackTours.scss';
</style>
